export class ClientBalanceReportFilter{
    isPaid: boolean;
    clientId: number;
    dateFrom?: string;
    dateTo?: string;
}


// WEBPACK FOOTER //
// ./src/app/models/reports/client.balance.report.filter.ts